(function () {
  'use strict';
  if (window.__pedalCartInlineNameBound) return;
  window.__pedalCartInlineNameBound = true;

  var CSS = [
    '.CartItemCustomName{margin:8px 0 0;}',
    '.CartItemCustomName__toggle{display:inline-flex;align-items:center;gap:6px;background:none;border:none;padding:0;cursor:pointer;font-size:12px;letter-spacing:0.08em;text-transform:uppercase;color:#111;text-decoration:underline;text-underline-offset:3px;}',
    '.CartItemCustomName__icon{font-size:14px;line-height:1;}',
    '.CartItemCustomName__panel{margin-top:10px;padding:12px;border:1px solid #000;background:#fafafa;}',
    '.CartItemCustomName__label{display:block;font-size:11px;letter-spacing:0.08em;text-transform:uppercase;color:#555;margin-bottom:6px;}',
    '.CartItemCustomName__input{width:100%;box-sizing:border-box;padding:9px 10px;border:1px solid #000;border-radius:0;font-size:14px;letter-spacing:0.06em;text-transform:uppercase;background:#fff;color:#111;}',
    '.CartItemCustomName__actions{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top:10px;}',
    '.CartItemCustomName__save{flex-shrink:0;background:#000;color:#fff;border:none;padding:9px 16px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;border-radius:4px;}',
    '.CartItemCustomName__save:hover{background:#222;}',
    '.CartItemCustomName__save[disabled]{opacity:0.5;cursor:default;}',
    '.CartItemCustomName__save.is-loading{opacity:0.6;cursor:wait;}',
    '.CartItemCustomName__hint{font-size:11px;color:#777;}',
    '.CartItemCustomName__msg{margin-top:8px;font-size:12px;}',
    '.CartItemCustomName__msg--error{color:#c0392b;}',
    '.CartItemCustomName__msg--ok{color:#1a8a4a;}'
  ].join('');

  var style = document.createElement('style');
  style.id = 'pedal-cart-inline-name-css';
  style.textContent = CSS;
  document.head.appendChild(style);

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw { description: 'Request failed.' }; });
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function parseNames(raw) {
    return (raw || '')
      .split(',')
      .map(function (s) { return s.trim().toUpperCase(); })
      .filter(function (s) { return s.length > 0; });
  }

  function makeOrderId() {
    return 'ORD-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9).toUpperCase();
  }

  function showMsg(container, text, isError) {
    var msg = container.querySelector('[data-cn-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.className = 'CartItemCustomName__msg ' + (isError ? 'CartItemCustomName__msg--error' : 'CartItemCustomName__msg--ok');
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function save(container) {
    var btn = container.querySelector('[data-cn-save]');
    var input = container.querySelector('[data-cn-input]');
    var bagKey = container.getAttribute('data-cn-bag-key');
    var chargeId = parseInt(container.getAttribute('data-cn-variant-id'), 10);
    var names = parseNames(input && input.value);

    if (!names.length) { showMsg(container, 'Please enter at least one name.', true); return; }
    if (!chargeId) { showMsg(container, 'Custom name option is unavailable right now.', true); return; }

    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    var orderId = makeOrderId();

    getCart()
      .then(function (cart) {
        var bag = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === bagKey) { bag = cart.items[i]; break; }
        }
        if (!bag) throw { description: 'This item is no longer in your cart.' };

        var stampedProps = {};
        var existing = bag.properties || {};
        Object.keys(existing).forEach(function (k) { stampedProps[k] = existing[k]; });
        stampedProps._Order_ID = orderId;

        var bagBody = { items: [{ id: bag.variant_id, quantity: bag.quantity, properties: stampedProps }] };
        if (bag.selling_plan_allocation && bag.selling_plan_allocation.selling_plan && bag.selling_plan_allocation.selling_plan.id) {
          bagBody.items[0].selling_plan = bag.selling_plan_allocation.selling_plan.id;
        }

        var chargeBody = {
          items: [{
            id: chargeId,
            quantity: names.length,
            properties: {
              'Custom Name': names.join(', '),
              'Custom Product': bag.product_title,
              'Variant Title': bag.variant_title,
              _Order_ID: orderId
            }
          }]
        };

        return jsonPost('/cart/add.js', bagBody)
          .then(function () { return jsonPost('/cart/add.js', chargeBody); })
          .then(function () { return jsonPost('/cart/change.js', { id: bagKey, quantity: 0 }); });
      })
      .then(function () { refreshCart(); })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        showMsg(container, (err && (err.description || err.message)) || 'Something went wrong. Please try again.', true);
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cn-toggle]');
    if (toggle) {
      var c = toggle.closest('[data-cart-cn]');
      var panel = c && c.querySelector('[data-cn-panel]');
      if (panel) {
        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
        if (willOpen) {
          var inp = panel.querySelector('[data-cn-input]');
          if (inp) inp.focus();
        }
      }
      return;
    }
    var saveBtn = e.target.closest('[data-cn-save]');
    if (saveBtn) {
      var container = saveBtn.closest('[data-cart-cn]');
      if (container) save(container);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest ? e.target.closest('[data-cn-input]') : null;
    if (!inp) return;
    e.preventDefault();
    var container = inp.closest('[data-cart-cn]');
    if (container) save(container);
  });
})();
